import React, { useState, useEffect, Fragment } from "react";
import { Button, Modal, FormGroup } from "react-bootstrap";

import { upsAddressFields } from "../Address/FormFields";
import {
  onSelectAddress,
  onAddAddress,
  onDeleteAddress,
  validateForm,
  resetValues,
  handleUpsAddressValidation,
  extractUPSAddress,
} from "./helpers";
import { DELETE_ICON } from "../../../../assets/js/image";
import UPSAddresses from "../Address/UPSAddresses";
import * as FieldConstants from "../../../../constants/FieldConstants";
// import { UPS_SAVE_ERR_MSG } from "../../../../constants/Constants";
import axios from "../../../../service/axios";
import OnSubmitErrorMessage from "../../../Common/Errors/OnSubmitErrorMessage";
import { objectEmpty } from "../Address/helpers";
import "./UPSAddressModal.css";

const UPSAddressModal = ({
  vendorProfileId,
  vendorDetails,
  showModal,
  toggleModal,
  updateUPSAddresses,
}) => {
  const initialState = {
    formValues: {
      duns: vendorDetails?.duns || "",
      email: vendorDetails?.userEmail || "",
      errors: {},
      validForm: false,
    },
    submitSuccess: null,
    valuesChanged: false,
    upsAccountAddress: extractUPSAddress({ ...vendorDetails, vendorProfileId }),
  };
  const [
    {
      formValues,
      upsAccountAddress,
      submitSucess,
      errorMessage,
      valuesChanged,
    },
    setFormValues,
  ] = useState({
    ...initialState,
    resetValues: {
      ...initialState,
    },
  });
  const [disableUPSSaveButton, setDisableUPSSaveButton] = useState(false);

  useEffect(() => {
    setFormValues((state) => ({
      ...state,
      formValues: {
        ...state.formValues,
        validForm: validateForm(upsAccountAddress),
      },
    }));
  }, [upsAccountAddress]);

  const handleSubmit = () => {
    setDisableUPSSaveButton(true);
    axios()
      .post(
        "/address/createMultipleAddress",
        upsAccountAddress?.map((item) => {
          return {
            ...item,
            email: vendorDetails?.userEmail || "",
            vendorProfileId: vendorProfileId || "",
            duns: vendorDetails?.duns || "",
          };
        })
      )
      .then((res) => {
        setDisableUPSSaveButton(false);
        updateUPSAddresses(res.data);
        setFormValues((state) => ({
          ...state,
          upsAccountAddress: res.data,
          resetValues: { ...state.resetValues, upsAccountAddress: res.data },
          valuesChanged: false,
        }));
        toggleModal();
      })
      .catch((error) => {
        setDisableUPSSaveButton(false);
        console.log(error);
        setFormValues((state) => ({
          ...state,
          submitSucess: false,
          errorMessage: error?.response?.data?.message,
        }));
      });
  };

  const handleClose = () => {
    resetValues(setFormValues);
    toggleModal();
  };

  return (
    <>
      <Modal contentClassName="upsAddressModal" show={showModal}>
        <Modal.Header onHide={handleClose} closeButton>
          <Modal.Title>Update UPS Account #'s and Addresses</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "445px", overflowY: "auto" }}>
          {submitSucess === false && (
            <OnSubmitErrorMessage message={errorMessage} type="error" />
          )}
          <div>
            {upsAccountAddress &&
              upsAccountAddress.map((address, index) => {
                return (
                  <Fragment key={`upsAddress${index}`}>
                    <UPSAddresses
                      handleValidate={handleUpsAddressValidation}
                      errors={formValues.errors}
                      formValues={formValues}
                      setFormValues={setFormValues}
                      upsAddressValues={address}
                      upsAddressFields={upsAddressFields}
                      vendorProfileId={vendorProfileId}
                      duns={formValues.duns}
                      addressIndex={index}
                      onSelectAddress={onSelectAddress}
                    />

                    {((upsAccountAddress.length > 1 &&
                      upsAccountAddress[1].id) ||
                      index !== 0) && (
                      <div
                        className="deleteAnotherAdd deleteAddress"
                        onClick={(e) =>
                          onDeleteAddress(
                            updateUPSAddresses,
                            setFormValues,
                            address,
                            index
                          )
                        }
                      >
                        <DELETE_ICON
                          style="deleteIcon"
                          id={FieldConstants.deleteIconId}
                        ></DELETE_ICON>
                        Delete Address
                      </div>
                    )}
                  </Fragment>
                );
              })}
            {upsAccountAddress && upsAccountAddress.length < 15 && (
              <div
                className="addAddress"
                onClick={() =>
                  onAddAddress(setFormValues, {
                    vendorProfileId: vendorProfileId,
                    duns: formValues.duns,
                    email: formValues.email,
                    category: "UPS",
                  })
                }
              >
                + Add Another UPS Account # and Address
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <FormGroup style={{ width: "100%", height: "35px" }}>
            <Button
              size="md"
              onClick={handleSubmit}
              className="button-primary-md float-right"
              style={{ margin: "0 10px" }}
              disabled={
                disableUPSSaveButton ||
                !formValues.validForm ||
                !objectEmpty(formValues.errors) ||
                !valuesChanged
              }
            >
              Save
            </Button>
            <Button
              id="updateAddrBtn"
              size="md"
              onClick={() => resetValues(setFormValues)}
              className="button-later-md float-right"
            >
              Cancel
            </Button>
          </FormGroup>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UPSAddressModal;
